import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IRopeTypeSize } from 'src/models/rope-type.model';
import style from './rope-size-conductor-list.module.scss';
import RopeSizeConductorAdd from '../rope-size-conductor-add/rope-size-conductor-add.component';
import RopeSizeConductorEdit from '../rope-size-conductor-edit/rope-size-conductor-edit.component';
import RopeSizeConductorDelete from '../rope-size-conductor-delete/rope-size-conductor-delete.component';

type IProp = {
  data: IRopeTypeSize[];
  loading: boolean;
};

const RopeSizeConductorView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IRopeTypeSize>[] = [
    {
      title: Lang.LBL_ROPE_SIZE,
      index: 'ropeType',
      width: '85%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <RopeSizeConductorEdit data={value} />
          <RopeSizeConductorDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[1].render) {
      customColumns[1].render(true, {} as IRopeTypeSize, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_MANAGE_ROPE_SIZE_CONDUCTOR} />
        <RopeSizeConductorAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default RopeSizeConductorView;
